<div class="auto ">
  <form [formGroup]="aboutForm" (ngSubmit)="submitForm()" class="auth-wrapper">
    <div class="auth-card ">
      <h2 class="title">Event Information</h2>
      <p class="subtitle">
        Help us understand your event organizing needs better
      </p>

      <div class="form-grid">

        <!-- Country / State / City -->
        <div class="field full chips">
          <label>Event Categories </label>

          <ng-select  class="chips_lite"  [items]="eventCategories" [multiple]="true" bindLabel="name" bindValue="name" [searchable]="true"
            placeholder="Select Event Categories" formControlName="categories">
          </ng-select>
          <small class="error"
            *ngIf="(aboutForm.get('categories')?.touched || submitted) && aboutForm.get('categories')?.invalid">
            Please select at least one category
          </small>
        </div>

        <div class="field">
          <label>Events Per Year </label>
          <ng-select [items]="eventsPerYearOptions" bindLabel="label" bindValue="label" [searchable]="true"
            placeholder="Select Events Per Year" formControlName="eventsPerYear">
          </ng-select>
          <small class="error"
            *ngIf="(aboutForm.get('eventsPerYear')?.touched || submitted) && aboutForm.get('eventsPerYear')?.invalid">
            Please select events per year
          </small>
        </div>

        <div class="field w-100">
          <label>Audience Size Per Event </label>
          <ng-select [items]="audienceSizeOptions" bindLabel="label" bindValue="label" [searchable]="true"
            placeholder="Select Audience Size Per Event" formControlName="audienceSize">
          </ng-select>
          <small class="error"
            *ngIf="(aboutForm.get('audienceSize')?.touched || submitted) && aboutForm.get('audienceSize')?.invalid">
            Please select audience size per event
          </small>
        </div>

      </div>

      <div class="note-box">
        All fields are optional. You can skip this step and complete it later from your dashboard.
      </div>

      <div class="actions">
        <button type="button" class="secondary-btn" (click)="back()">Back</button>
        <div class="skips">

          <button type="button" class="skip_btn" (click)="navigateStep()" *ngIf="!formfillNext">

            Skip
          </button>

          <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
          <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next </button>

        </div>
      </div>

    </div>

    <div class="step-dots">
      <span class="dot"></span>
      <span class="dot "></span>
      <span class="dot active"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </form>
</div>
<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>